import React from "react";
import { News } from "../../models/News";

export interface NewsUIProps {
  iID: string;
  title: string;
  teaser: string;
  pictures: {
    threeTwo: string;
  };
  link: string;
  publishedDate: Date;
}

export const NewsUI: React.FC<NewsUIProps> = ({
  iID,
  title,
  pictures,
  link,
  publishedDate,
}) => {
  const formattedDate = new Intl.DateTimeFormat("da-DK", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(publishedDate);

  return (
    <div className="col-md-4" id={iID}>
      <a href={link}>
        <img
          src={pictures.threeTwo}
          className="img-fluid rounded news-img"
          alt={title}
        />
        <h4 className="overview-title">{title}</h4>
        <p className="overview-details">
          <span className="date">{formattedDate}</span>
        </p>
      </a>
    </div>
  );
};

export interface featuredNewsProps {
  iID: string;
  title: string;
  pictures: {
    threeTwo: string;
  };
  link: string;
  publishedDate: Date;
  containerId: string;
}

export const NewsUIFeatured: React.FC<featuredNewsProps> = ({
  iID,
  title,
  pictures,
  link,
  publishedDate,
  containerId,
}) => {
  const formattedDate = new Intl.DateTimeFormat("da-DK", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(publishedDate);
  return (
    <div className="col-md-12 pos-relative border-radius-15 overflow-hidden">
      <a href={link}>
        <div className="overlay">
          <img
            src={pictures.threeTwo}
            alt="Item"
            className="img-fluid rounded w-100"
          />
        </div>

        <div className="col-12 gradient details-wrapper d-flex flex-column-reverse">
          <p className="articles-overview-details">
            <span className="date">{formattedDate}</span>
          </p>
          {containerId === "item-1" ? (
            <h1 className="articles-overview-title">{title}</h1>
          ) : (
            <h2 className="articles-overview-title">{title}</h2>
          )}
        </div>
      </a>
    </div>
  );
};
